const success = {
  25: '#FAFFFD',
  50: '#ECFDF7',
  100: '#D1FAEC',
  200: '#A7F3DA',
  300: '#6EE7BF',
  350: '#34C759',
  400: '#34D39E',
  500: '#10B981',
  600: '#059666',
  700: '#047852',
  800: '#065F42',
  900: '#022C1E',
};
export default success;